import React, { useState } from 'react';
import * as Unicons from '@iconscout/react-unicons';
import AdminLayout from '../../components/layout/admin';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import './styles.scss';
import RaterInputForm from './RaterInputForm';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getMasterRater } from '../../services/masterRater';
import { useHistory, useParams } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import {
  getRaterFormDetail,
  postRaterForm,
  updateRaterForm
} from '../../services/raterForm';
import { showNotification } from '../../utilities/mantineNotification';

const RaterFormEditPage = (props) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [dataPayload, setDataPayload] = useState(null);

  const history = useHistory();
  const params: any = useParams();
  // Queries
  const fetchedRaterForm = useQuery({
    queryKey: ['getMasterRater'],
    queryFn: () =>
      getMasterRater({
        page: 1,
        userin: params.userid,
        scheduleid: params.id
      })
  });

  const detailRATER = useQuery({
    queryKey: ['getRaterFormDetail'],
    queryFn: () => getRaterFormDetail(params?.id)
  });

  const inputRaterForm = useMutation({
    mutationFn: updateRaterForm,
    onSuccess: () => {
      fetchedRaterForm.refetch();
      close();
      showNotification({
        type: 'success',
        message: 'Rater Form Updated'
      });
      history.push({
        pathname: '/management/rater-form/detail/' + params.id
      });
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const handleSubmit = (payload) => {
    const payloadMod = {
      ...payload,
      scheduleRaterID: detailRATER.data?.data?.data[0]?.scheduleRaterID,
      insertID: params.id,
      userID: params.userid,
      userIn: params.userid
    };
    // console.log(payloadMod);
    setDataPayload(payloadMod);
    open();
  };

  const handleConfirmSubmit = () => {
    inputRaterForm.mutate(dataPayload);
  };

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="RATER Edit Form"
        itemList={[
          {
            title: 'RATER',
            href: '#',
            icon: <Unicons.UilFileCopyAlt size={16} />
          },
          {
            title: 'Detail Rater Form',
            href: '/management/rater-form/detail/' + params.id
          }
        ]}
      />

      <RaterInputForm
        questions={fetchedRaterForm?.data?.data?.data}
        onSubmit={handleSubmit}
        type="rater"
      />

      <ModalConfirmation
        isVisible={opened}
        onCancel={() => close()}
        onConfirm={() => handleConfirmSubmit()}
      />
    </AdminLayout>
  );
};

export default RaterFormEditPage;
